import graph from "../../utils/services/graph"
import {getLinkedCardsErrorHandler, removeLinkedCardErrorHandler} from "./errors/card"

const service = {}

export const card = `
  uuid
  userUuid
  fidelCardUuid
  countryCode
  lastFour
  expMonth
  expYear
  syncToFidelError
  createdBy
  createdAt
  updatedBy
  updatedAt
`

service.list = (userUuid, sort = null, options = {}) => {
  const query = `
    query CardList($userUuid: String!, $sort: String) {
      cards(userUuid: $userUuid, sort: $sort){
        results {
          ${card}
        }
      }
    }
  `

  return graph({query, variables: {userUuid, sort}}, options)
    .then((response) => response.cards && response.cards.results)
    .catch(getLinkedCardsErrorHandler)
}

service.remove = (cardUuid, options = {}) => {
  const query = `
    mutation RemoveCard($cardUuid: String!) {
      removeCard(cardUuid: $cardUuid)
    }
  `

  return graph({query, variables: {cardUuid}}, options).catch(removeLinkedCardErrorHandler)
}

export const removeCard = service.remove
export const getCards = service.list

export default service
